import { kLocalStorageKeys } from "./constants/kLocalStorageKeys";

export default function collectUTM() {
    let utm_campaign = new URLSearchParams(window.location.search).get("utm_campaign");
	if (utm_campaign) {
		sessionStorage.setItem(kLocalStorageKeys.Session.utmCampaign, utm_campaign);
	}
    return null;
}